
import { useState } from "react";
import { Card } from "@/components/ui/card";
import VerificationCountryCard from "./components/VerificationCountryCard";
import PersonalInfoCard from "./components/PersonalInfoCard";
import UploadedDocumentsCard from "./components/UploadedDocumentsCard";
import TermsAgreement from "./components/TermsAgreement";
import SubmitButton from "./components/SubmitButton";
import { useDocumentSubmission } from "./hooks/useDocumentSubmission";

interface VerificationStep4Props {
  formData: any;
  onSubmit: () => void;
}

const VerificationStep4 = ({ formData, onSubmit }: VerificationStep4Props) => {
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const { isSubmitting, handleSubmit } = useDocumentSubmission({
    formData,
    onSubmit,
    agreedToTerms
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold mb-2">Review & Submit</h2>
        <p className="text-muted-foreground mb-6">
          Please review your information before submitting your verification request.
        </p>
      </div>

      <VerificationCountryCard 
        countryCode={formData.verificationCountry}
        residencyStatus={formData.personalInfo.residency_status} 
      />

      <PersonalInfoCard personalInfo={formData.personalInfo} />

      <UploadedDocumentsCard documents={formData.documents || []} />

      <div className="space-y-4 mt-6">
        <TermsAgreement
          agreedToTerms={agreedToTerms}
          setAgreedToTerms={setAgreedToTerms}
        />
        
        <SubmitButton
          isSubmitting={isSubmitting}
          disabled={!agreedToTerms}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default VerificationStep4;
